import intl from "react-intl-universal";
import { TbCalendar, TbCurrencyReal, TbSwitchHorizontal } from "react-icons/tb";
import { CurrencyIcon } from "../../../../Components/Atoms/CurrencyIcon";
import { ModernFilterBar } from "../../../../Components/Molecules/Filters/ModernFilterBar";
import {
  AmountFilterPanel,
  CheckboxListFilterPanel,
  DateFilterPanel,
  MoreFiltersAmountSection,
  MoreFiltersCheckboxSection,
  MoreFiltersDateSection,
} from "../../../../Components/Molecules/Filters/ModernFilterPanels";
import {
  CI_HISTORY_CURRENCIES,
  EMPTY_CONTA_INTERNACIONAL_HISTORY_FILTERS,
  buildContaInternacionalHistoryFilterTags,
  exportContaInternacionalHistoryCsv,
  getCiHistoryStatuses,
  getCiHistoryTypes,
  getCiPaymentMethodOptions,
  hasActiveContaInternacionalHistoryFilters,
  isContaInternacionalChipFilterActive,
  removeContaInternacionalHistoryFilterTag,
} from "../contaInternacionalHistoryFilters";

const CiCurrencyFilterIcon = ({ asset }) => <CurrencyIcon asset={asset} size={18} />;

const getCiCurrencyOptionIcon = (option) => {
  const Icon = () => <CiCurrencyFilterIcon asset={option.id} />;
  return Icon;
};

const CiCurrencyFilterButtonIcon = ({ className }) => (
  <CurrencyIcon asset="usd" size={16} className={className} />
);

const ContaInternacionalMoreFiltersForm = ({ draft, onChange }) => {
  const statuses = getCiHistoryStatuses();
  const types = getCiHistoryTypes();
  const paymentMethods = getCiPaymentMethodOptions();

  return (
    <div className="extract-more-filters-form">
      <MoreFiltersDateSection draft={draft} onChange={onChange} />
      <MoreFiltersAmountSection
        draft={draft}
        onChange={onChange}
        idPrefix="ci-more"
        minLabelKey="contaInternacional.amountMin"
        maxLabelKey="contaInternacional.amountMax"
      />
      <MoreFiltersCheckboxSection
        label={intl.get("contaInternacional.filterCurrency")}
        options={CI_HISTORY_CURRENCIES}
        selectedValues={draft.currencies}
        onChange={(currencies) => onChange({ ...draft, currencies })}
        idPrefix="ci-more-currency"
        getOptionIcon={getCiCurrencyOptionIcon}
      />
      <MoreFiltersCheckboxSection
        label={intl.get("grid.status")}
        options={statuses}
        selectedValues={draft.statuses}
        onChange={(statuses) => onChange({ ...draft, statuses })}
        idPrefix="ci-more-status"
      />
      <MoreFiltersCheckboxSection
        label={intl.get("contaInternacional.filterType")}
        options={types}
        selectedValues={draft.types}
        onChange={(types) => onChange({ ...draft, types })}
        idPrefix="ci-more-type"
      />
      <MoreFiltersCheckboxSection
        label={intl.get("contaInternacional.filterPaymentMethod")}
        options={paymentMethods}
        selectedValues={draft.paymentMethods}
        onChange={(paymentMethods) => onChange({ ...draft, paymentMethods })}
        idPrefix="ci-more-payment"
      />
    </div>
  );
};

export const ContaInternacionalHistoryFilterBar = ({
  filters,
  onFiltersChange,
  filteredItems,
}) => {
  const typeOptions = getCiHistoryTypes();

  const filterButtons = [
    {
      id: "date",
      icon: TbCalendar,
      label: intl.get("extract.filterDate"),
      active: isContaInternacionalChipFilterActive(filters, "date"),
    },
    {
      id: "amount",
      icon: TbCurrencyReal,
      label: intl.get("extract.filterAmount"),
      active: isContaInternacionalChipFilterActive(filters, "amount"),
    },
    {
      id: "currency",
      icon: CiCurrencyFilterButtonIcon,
      label: intl.get("contaInternacional.filterCurrency"),
      active: isContaInternacionalChipFilterActive(filters, "currency"),
    },
    {
      id: "type",
      icon: TbSwitchHorizontal,
      label: intl.get("contaInternacional.filterType"),
      active: isContaInternacionalChipFilterActive(filters, "type"),
    },
  ];

  const renderPanelContent = (panelId, draft, onChange) => {
    switch (panelId) {
      case "date":
        return <DateFilterPanel draft={draft} onChange={onChange} />;
      case "amount":
        return (
          <AmountFilterPanel
            draft={draft}
            onChange={onChange}
            idPrefix="ci-filter"
            minLabelKey="contaInternacional.amountMin"
            maxLabelKey="contaInternacional.amountMax"
          />
        );
      case "currency":
        return (
          <CheckboxListFilterPanel
            options={CI_HISTORY_CURRENCIES}
            selectedValues={draft.currencies}
            onChange={(currencies) => onChange({ ...draft, currencies })}
            idPrefix="ci-currency"
            getOptionIcon={getCiCurrencyOptionIcon}
          />
        );
      case "type":
        return (
          <CheckboxListFilterPanel
            options={typeOptions}
            selectedValues={draft.types}
            onChange={(types) => onChange({ ...draft, types })}
            idPrefix="ci-type"
          />
        );
      default:
        return null;
    }
  };

  return (
    <ModernFilterBar
      filters={filters}
      onFiltersChange={onFiltersChange}
      emptyFilters={EMPTY_CONTA_INTERNACIONAL_HISTORY_FILTERS}
      searchPlaceholder={intl.get("extract.searchTransaction")}
      filterButtons={filterButtons}
      moreFiltersActive={isContaInternacionalChipFilterActive(filters, "more")}
      buildFilterTags={buildContaInternacionalHistoryFilterTags}
      hasActiveFilters={hasActiveContaInternacionalHistoryFilters}
      removeFilterTag={removeContaInternacionalHistoryFilterTag}
      onExport={exportContaInternacionalHistoryCsv}
      filteredItems={filteredItems}
      renderPanelContent={renderPanelContent}
      renderMoreFilters={(draft, onChange) => (
        <ContaInternacionalMoreFiltersForm draft={draft} onChange={onChange} />
      )}
      panelTitles={{
        date: intl.get("extract.filterDate"),
        amount: intl.get("extract.filterAmount"),
        currency: intl.get("contaInternacional.filterCurrency"),
        type: intl.get("contaInternacional.filterType"),
      }}
    />
  );
};
